import {
  ServiceType,
  useGetParkingLocationV2Query,
  useGetWashingLocationV2Query,
} from '../../codegen/locations';

export const useLocations = (locationId: string, serviceType: string) => {
  if (serviceType === ServiceType.Parking) {
    const parkingLocationsQuery = useGetParkingLocationV2Query({
      id: locationId,
    });

    return {
      location: parkingLocationsQuery.data,
      isLoading: parkingLocationsQuery.isLoading,
      error: parkingLocationsQuery.error,
    };
  } else if (serviceType === ServiceType.Washing) {
    const washingLocationsQuery = useGetWashingLocationV2Query({
      id: locationId,
    });

    return {
      location: washingLocationsQuery.data,
      isLoading: washingLocationsQuery.isLoading,
      error: washingLocationsQuery.error,
    };
  } else {
    return {
      location: undefined,
    };
  }
};
